import { cva } from 'class-variance-authority'

// Styles for the SliderPrimitive.Root
export const rootStyles = cva(
  `
    relative
    flex
    w-full
    touch-none
    select-none
    items-center
  `
)

// Styles for the SliderPrimitive.Track
export const trackStyles = cva(
  `
    relative
    h-1.5
    w-full
    grow
    overflow-hidden
    rounded-full
    bg-neutral-200
  `
)

// Styles for the SliderPrimitive.Range
export const rangeStyles = cva(
  `
    absolute
    h-full
    bg-moss-200
  `
)

// Styles for the SliderPrimitive.Thumb
export const thumbStyles = cva(
  `
    block
    h-4
    w-4
    rounded-full
    border
    border-neutral-400
    bg-neutral-0
    shadow
    transition-colors
    cursor-pointer
    focus-visible:outline-none
    focus-visible:ring-1
    focus-visible:ring-ring
    disabled:pointer-events-none
    disabled:opacity-50
  `
)
